<script setup>
import { useSettingsStore } from '../../stores/settings';
import Select from '../../../../library/form/components/Select.vue';

const { labels } = window.DATAGENT_PLUGIN_SETTINGS;

// Get the settings store
const settingsStore = useSettingsStore();

// handle model change
const handleModelChange = (e) => {
  if (e?.target?.value) {
    settingsStore.openrouter.model = e.target.value;
  }
};
</script>

<template>
  <div
    id="dataagent-openrouter-settings"
    class="dataagent-provider-settings da:mt-4 da:pt-4 da:border-t da:border-[#f5f5f5] da:transition-all da:duration-300 da:ease-in-out"
    :style="{ display: settingsStore.selectedProvider === 'openrouter' ? 'block' : 'none' }"
  >
    <table class="form-table">
      <!-- OpenRouter API Key -->
      <tr>
        <th scope="row">
          <label for="dataagent_openrouter_api_key" class="da:block da:text-sm da:font-medium da:text-gray-700">{{
            labels.openrouter_api_key
          }}</label>
        </th>
        <td>
          <input
            type="password"
            id="dataagent_openrouter_api_key"
            v-model="settingsStore.openrouter.apiKey"
            @input="settingsStore.fetchOpenRouterModels"
            class="regular-text da:w-full md:da:w-[250px] da:px-3 da:py-2 da:border da:border-gray-300 da:rounded-md da:shadow-sm da:focus:outline-none da:focus:ring-[#4CB21A] da:focus:border-[#4CB21A]"
          />
          <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">
            {{ labels.openrouter_api_key_description }}
          </p>
        </td>
      </tr>

      <!-- OpenRouter Model -->
      <tr>
        <th scope="row">
          <label for="dataagent_openrouter_model" class="da:block da:text-sm da:font-medium da:text-gray-700">{{
            labels.openrouter_model
          }}</label>
        </th>
        <td>
          <template v-if="settingsStore.openrouter.apiKey.length < 10">
            <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">
              {{ labels.enter_api_key_to_load_models }}
            </p>
          </template>
          <template v-else>
            <Select
              id="dataagent_openrouter_model"
              @change="handleModelChange"
              :disabled="settingsStore.openrouter.modelsLoading"
              class="select2 regular-text da:w-full md:da:w-[250px] da:px-3 da:py-2 da:border da:border-gray-300 da:rounded-md da:shadow-sm da:focus:outline-none da:focus:ring-[#4CB21A] da:focus:border-[#4CB21A] da:bg-white da:cursor-pointer"
              :value="settingsStore.openrouter.model"
              :options="settingsStore.openrouter.models"
            />
            <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">
              {{ labels.openrouter_model_description }}
            </p>
          </template>
        </td>
      </tr>
    </table>
  </div>
</template>
